export default __webpack_public_path__ + "static/cashflow_new_7-b8d5ac8fa8ca168ab37de2a00bda0601.jpg";